import styled from 'styled-components';
import { stickyYellow } from 'tokens';

export const StickyNote = styled.div`
	position: fixed;
	width: 280px;
	max-height: 500px;
	background: ${stickyYellow.fill};
	border: 1px solid ${stickyYellow.border};
	border-radius: 3px;
	box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.2), 1px 1px 4px rgba(0, 0, 0, 0.1);
	z-index: 2;
	display: flex;
	flex-direction: column;

	// Corner fold
	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		right: 0;
		width: 16px;
		height: 16px;
		background: linear-gradient(135deg, ${stickyYellow.fold} 50%, ${stickyYellow.foldShadow} 50%);
		border-radius: 0 0 3px 0;
	}
`;

export const StickyHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 6px 8px;
	border-bottom: 1px solid ${stickyYellow.border};
	flex-shrink: 0;
`;

export const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 2px;
`;

export const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 2px;
`;

export const NavArrow = styled.button`
	background: none;
	border: none;
	font-size: 10px;
	line-height: 1;
	color: ${stickyYellow.text};
	opacity: 0.5;
	padding: 2px 4px;
	border-radius: 3px;

	&:hover {
		opacity: 1;
		background: rgba(0, 0, 0, 0.08);
	}
`;

export const NavLabel = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${stickyYellow.text};
	white-space: nowrap;
	padding: 0 2px;
`;

export const HeaderButton = styled.button`
	background: none;
	border: none;
	font-size: 11px;
	color: ${stickyYellow.text};
	opacity: 0.5;
	padding: 2px 6px;
	border-radius: 3px;

	&:hover {
		opacity: 1;
		background: rgba(0, 0, 0, 0.08);
	}
`;

export const EditableText = styled.textarea`
	font-size: 14px;
	line-height: 1.6;
	color: ${stickyYellow.text};
	background: transparent;
	border: none;
	outline: none;
	resize: none;
	padding: 10px 12px;
	margin: 0;
	font-family: inherit;
	word-break: break-word;
	overflow-y: hidden;
	min-height: 60px;
`;
